const STORAGE_KEY = "yongyuan-selector-auto-prompt";
export const AUTO_PROMPT_TTL_MS = 24 * 60 * 60 * 1000;

function readRecord() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.until !== "number") return null;
    return parsed;
  } catch {
    return null;
  }
}

function clearRecord() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore quota / private mode errors
  }
}

export async function fetchClientIp() {
  try {
    const response = await fetch("https://api.ipify.org?format=json", {
      cache: "no-store",
    });
    if (!response.ok) return "";
    const data = await response.json();
    return typeof data.ip === "string" ? data.ip : "";
  } catch {
    return "";
  }
}

export function isAutoPromptSuppressed(ip = "") {
  const record = readRecord();
  if (!record) return false;

  if (Date.now() >= record.until) {
    clearRecord();
    return false;
  }

  if (record.ip && ip) {
    return record.ip === ip;
  }

  // IP 获取失败时，退化为同一浏览器 24 小时内不再自动弹
  return true;
}

/**
 * 抑制自动弹窗 24h。仅应在以下时机调用：
 * - 居中自动弹窗已真正展示（或用户关闭了它）
 * - 用户成功提交表单（含手动打开后提交）
 * 手动打开表单本身不应调用，以免误伤后续自动提醒。
 */
export function markAutoPromptDismissed(ip = "") {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ip: ip || "",
        until: Date.now() + AUTO_PROMPT_TTL_MS,
      })
    );
  } catch {
    // ignore quota / private mode errors
  }
}
